import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';

const Learn = lazy(() => import('@/pages/Learn'));

/**
 * `tab` keeps Learn's tab in the URL while Speedies (F-129) are on, so Back and shared links land on
 * the right tab. With the flag off Learn never writes it (the tab is local state, as before). An
 * unknown value is ignored (an old ?tab=challenges link lands on My Learning; that tab went 3 Nov).
 */
const learnSearchSchema = z.object({
  tab: z
    .enum(['courses', 'speedy', 'recordings', 'my-learning', 'badges', 'leaderboard'])
    .optional()
    .catch(undefined),
  /** Speedies on one topic (a `groups` key), e.g. from a feed carousel's topic link. */
  topic: z.string().regex(/^[a-z_]{2,40}$/).optional().catch(undefined),
});

export type LearnSearchParams = z.infer<typeof learnSearchSchema>;

export const Route = createFileRoute('/learn/')({
  validateSearch: (search: Record<string, unknown>): LearnSearchParams => learnSearchSchema.parse(search),
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <Learn />
    </Suspense>
  ),
});
